import { useState } from "react";

type ToggleState = Record<string, boolean>;

const useToggle = () => {
    const [expandedItems, setExpandedItems] = useState<ToggleState>({});

    const toggle = (id: string) => {
        setExpandedItems((prev) => ({
            ...prev,
            [id]: !prev[id], 
        }));
    };

    const isExpanded = (id: string): boolean => !!expandedItems[id];

    return { expandedItems, toggle, isExpanded };
};

export default useToggle;
